<template>
  <div id="speaker">
    <span class="text active">
      {{ text }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { setCondition } from "../mixins/setCondition";

export default {
  //TODO: Events an Conditions knüpfen
  //TODO: Audiodateien erlauben

  name: "Speaker",
  mixins: [setCondition],
  components: {},
  props: {
    interaction: Object,
    line: String,
  },
  data() {
    return {
      c: false,
      e: false,
      a: false,
      fa: false,
      in: false,
      out: false,
      camera: false,
      currentText: 0,
      isArray: false,
    };
  },
  computed: {
    ...mapGetters([
      "conditions",
      "speaker",
      "chapters",
      "waitingForMo",
      "events",
      "event",
      "items",
      "fakeActionMode",
      // ...
    ]),
    text() {
      //    if ("c0" in this.interaction && this.waitingForMo) {
      /*
      if (this.waitingForMo) {
        let i = this.checkConditions(this.interaction);
        return this.checkActions(i);
      }
      return "";
      */
      if (this.waitingForMo) {
        return this.line;
      }
      return "";
    },
  },
  created() {
    this.$root.$refs.speaker = this;
  },
  mounted() {},
  methods: {
    /*checkConditions(interaction) {
      if ("default" in interaction) {
        for (let condition in interaction) {
          if (condition != "default") {
            if (condition in this.conditions) {
              if (this.conditions[condition].check == true) {
                return interaction[condition];
              }
            } //check if condition is item
            if (condition in this.items) {
              if (this.items[condition].inMantu == true) {
                return interaction[condition];
              }
            }
          }
        }
        return interaction.default;
      }
      return interaction;
    },
    checkActions(interaction, runFakeAction = false) {
      this.c = false;
      this.e = false;
      this.a = false;
      this.go = false;
      this.in = false;
      this.out = false;

      let i = interaction;
      if (interaction.constructor === Array) {
        this.isArray = true;
        i = interaction[this.currentText];
      } else {
        this.isArray = false;
      }
      if (i.constructor === Object) {
        if ("setCondition" in i) {
          this.c = i.setCondition;
        }
        if ("startEvent" in i) {
          this.e = i.startEvent;
        }
        if ("startFakeAction" in i) {
          if (runFakeAction || !this.fakeActionMode) {
            this.$store.commit("startFakeAction", [
              i.startFakeAction,
              i.videos,
            ]);
          } else {
            this.$store.commit("prepareFakeAction", [
              i.startFakeAction,
              i.videos,
            ]);
          }
        } else if ("changeCamera" in i) {
          this.$store.commit("stopFakeAction");
          this.changeCamera(i.changeCamera);
        }
        if ("action" in i) {
          this.a = i.action;
        }
        if ("go" in i) {
          this.go = i.go;
        }
        if ("in" in i) {
          this.in = i.in;
        }
        if ("out" in i) {
          this.out = i.out;
        }
        return i.text;
      }
      return i;
    },
    continue() {
      let wait = false;
      //Conditions
      if (this.c) {
        this.setCondition(this.c);
      }
      //Action
      if (this.a) {
        let command = { text: this.a };
        this.$parent.setCommand({ text: ">>clear" });
        this.$parent.setCommand(command);
        this.$parent.sendCommand();
      }
      //Events
      if (this.e) {
        this.$store.commit("playEvent", this.events[this.e].video);
        this.$store.commit("mute");
        if ("wait" in this.events[this.e]) {
          if (this.events[this.e].wait) {
            this.$parent.setCommand({ text: ">>clear" });
            this.$parent.setCommand({ text: ">wait:" });
            this.$parent.sendCommand();
            this.$store.commit("skip", true);
            wait = true;
          }
        }
      }
      //change chapter
      if (this.go) {
        if ("onenter" in this.chapters[this.go]) {
          //  this.$parent.interaction = this.chapters[this.go].onenter;
          this.$parent.startAction(this.chapters[this.go].onenter, true);
        }
      }
      //take items
      if (this.in) {
        if (Array.isArray(this.in)) {
          for (let item of this.in) {
            this.$parent.takeItem(item);
          }
        } else {
          this.$parent.takeItem(this.in);
        }
      }
      //remove items
      if (this.out) {
        if (Array.isArray(this.out)) {
          for (let item of this.out) {
            this.$parent.removeItem(item);
          }
        } else {
          this.$parent.removeItem(this.out);
        }
      }
      let i = this.checkConditions(this.interaction);
      if (this.isArray && i.length > this.currentText + 1) {
        this.currentText++;
      } else {
        this.currentText = 0;
        this.$store.commit("continue");
      }
      if (!wait) {
        this.$parent.continue();
      }
    },
    changeCamera(camera) {
      console.log("camera: " + camera);
    },*/
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.active {
  color: #353535;
  background: white;
}
.text {
  //    color: white;
}
</style>
